import { render, staticRenderFns } from "./OCRComponent.vue?vue&type=template&id=0e1c583c&scoped=true&"
import script from "./OCRComponent.vue?vue&type=script&lang=js&"
export * from "./OCRComponent.vue?vue&type=script&lang=js&"
import style0 from "./OCRComponent.vue?vue&type=style&index=0&id=0e1c583c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1c583c",
  null
  
)

export default component.exports